<template>
  <div class="section-main__warp reserveSet-page">
    <ioc-table
      ref="crud"
      :data="reserveSetData"
      :option="option"
      :page="page"
      @search-change="getList"
      @search-reset="getList"
      @size-change="sizeChange"
      @current-change="pageChange"
    >
      <template slot="status" slot-scope="scope">
        <el-switch
          v-model="scope.row.status"
          active-value="1"
          inactive-value="0"
          @change="handleUpdateStatus(scope.row)"
        ></el-switch>
        {{
          scope.row.status === "1"
            ? $t("reserve.button.abled")
            : $t("reserve.button.disadled")
        }}
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('reserve.button.look')"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            @click="handleUpdate('view', scope.row)"
            icon="iconfont icon-Detail"
          >
          </el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            :disabled="scope.row.status == '1'"
            type="text"
            v-auth="'/reserve/reserveplan:update'"
            icon="iconfont icon-xiugai"
            @click="handleUpdate('edit', scope.row)"
          >
          </el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('linkage.button.delete')"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            :disabled="scope.row.status == '1'"
            type="text"
            icon="el-icon-delete"
            v-auth="'/reserve/reserveplan:delete'"
            @click="handleDel(scope.row)"
          >
          </el-button>
        </el-tooltip>
      </template>
      <template slot="menuLeft">
        <el-button
          v-auth="'/reserve/reserveplan:add'"
          type="primary"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleUpdate('add')"
        >
          新增
        </el-button>
      </template>
    </ioc-table>

    <ReserveAdd
      :pageStates="pageStates"
      @updateTable="getListData"
      ref="refReserveAdd"
    ></ReserveAdd>
  </div>
</template>
<script>
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../const/table";
import ReserveAdd from "./reserveAdd";
export default {
  components: {
    ReserveAdd,
  },
  data() {
    return {
      pageStates: "add",
      reserveSetData: [],
      option: tableOption(this),
      searchForm: {},
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    handleDel(row) {
      let params = {
        emergencyPlanCodeList: [row.emergencyPlanCode],
      };
      this.$confirm(this.$t("reserve.label.eitherDel"), "删除确认", {
        confirmButtonText: this.$t("base.title.confirm"),
        cancelButtonText: this.$t("reserve.button.cancel"),
        type: "warning",
      }).then(() => {
        this.$fetch(api.reserve.deleteEmergencyPlan, params)
          .then((response) => {
            if (response.success) {
              this.$message({
                message: response.msgContent,
                type: "success",
              });
              this.page.pageNo = 1;
              this.getListData();
            } else {
              this.$message({
                type: "warning",
                message: response.msgContent,
              });
            }
          })
          .catch(() => {});
      });
    },
    handleUpdate(type, row) {
      this.pageStates = type;
      this.$nextTick(() => {
        this.$refs.refReserveAdd.handleShowPanel(row);
      });
    },

    handleUpdateStatus(row) {
      let newValue = row.status;
      if (newValue == "0") {
        row.status = "1";
      } else {
        row.status = "0";
      }
      this.$confirm(
        row.status === "0"
          ? "预案启用后立即生效，请确认预案相关的指挥组织管理人员及配套设施已准备完成，您确定立即启用吗？"
          : "预案禁用后将不会被告警触发，您确定立即禁用吗？",
        "操作确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.openOrClose(row);
        })
        .catch(() => {
          //
        });
    },
    openOrClose(row) {
      let params = {
        emergencyPlanCode: row.emergencyPlanCode,
        status: row.status == "0" ? 1 : 0,
      };
      this.$fetch(api.reserve.activeEmergencyPlan, params).then((response) => {
        if (response.success) {
          row.status = row.status == "0" ? "1" : "0";
          this.$message({
            message: response.msgContent,
            type: "success",
          });
        } else {
          this.$message({
            type: "warning",
            message: response.msgContent,
          });
        }
      });
    },
    getList(params) {
      this.searchForm = params;
      this.getListData();
    },
    getListData() {
      let params = {
        ...this.searchForm,
        ...this.page,
        // alarmTypeList: this.params.alarmTypeList,
        // emergencyPlanName: this.params.name, // 预案名称
        // type: this.params.class, // 预案类型
        // level: this.params.level, // 预案级别
        // status: this.params.status, // 预案状态
        // pageNum: this.page.pageNum,
        // pageSize: this.page.pageSize,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.reserve.getEmergencySetList, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);

        if (res.success) {
          this.page.total = res.returnObj.total;
          this.reserveSetData = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.pageNum = 1;
      this.getListData();
    },
    pageChange(pageNo) {
      this.page.pageNum = pageNo;
      this.getListData();
    },
  },
};
</script>
